/**
 * @title cashcard.js: Sub-module of Account feature
 * @description This module provides validation and submission of the cash card form
 * @dependency utility.js
 */
define(['wallet','applepay'], function(wallet,applepay) {
	var CashCard = {
			init : function() {
				$('#cash-card-check-balance').unbind('click').on('click', CashCard.checkBalance);
				$('#cash-card-check-balance-mobile').unbind('click').on('click', CashCard.checkBalance);
				
				COSTCO.CC.addLinkRefresh();				
			},
			
			addLinkRefresh : function(){
				if(typeof hasCashCard != "undefined" && hasCashCard){
					$('#add-another-cash-card').removeClass('hide');
				}
				if(typeof hasGom != "undefined" && hasGom){
					$('#add-another-gom-card').removeClass('hide');
				}
			},
			
			unhideInput : function(){
				$('#cashcard-block-form').removeClass('hide');
				if(!wallet.isComplete()){
				  $('#address-container-billing').removeClass('hide');
			  }
			},
			
			unhideInput_v2 : function(){
				COSTCO.CC.unhideInput();
				$('#cash-card-title').removeClass("hide");
				$('#add-cash-card-button').hide();
				$('#cashcard-check-balance-link').hide();
				if(!COSTCO.CC.isCybersourceEnabled()) 
					$("#cashcard-form").find("iframe").get(0).focus();
			},
			
			validationRules : function() { 
				$.validator.addMethod("cashcardpin", function( value, element ) {
					// costco pins are 12 digits
					return this.optional(element) ||  /^\d{4,8}$/.test(value);
				}, "Invalid PIN. Check your entry for accuracy and try again.");
				$.validator.addMethod("cashcard", function( value, element ) {
					// costco membership numbers are 12 digits
					return this.optional(element) || /^\d{16}(\d{3})?$/.test(value.split(" ").join(""));
				}, "You have entered an invalid Cash Card number. Check entry for accuracy and try again.");	
				$.validator.addMethod("checkoutajaxcashcardpin", function( value, element ) {
					return this.optional(element) || /^[*]{4,8}$/.test(value);
				}, "Invalid PIN. Check your entry for accuracy and try again.");
				$.validator.addMethod("checkoutajaxcashcard", function( value, element ) {
					return this.optional(element) || /^\d{6}[*]{6}\d{4}?$/.test(value);
				}, "You have entered an invalid Cash Card number. Check entry for accuracy and try again.");
			},
			
			validateCashCard : {	
				cashCardForm : function(form) {
					let cashPinError = messages.ERR_INVALID_CASHCARDPIN;
					let cashCardNumberError = messages.ERR_INVALID_CASHCARDNO;
					
					if($(form).length != 0) {
						$(form).validate({
							rules : { 
								cashcard: { required:true, cashcard:true},
								cashcardpin: { required:true, cashcardpin:true }
							},
							messages: {
								cashcard: {required: cashCardNumberError, cashcard: cashCardNumberError},
								cashcardpin:{required: cashPinError, cashcardpin: cashPinError},
							},
					        highlight: COSTCO.util.highlightWithErrorLabel,
					        unhighlight: COSTCO.util.unhighlightWithErrorLabel
						})
					}
					return $(form).valid();
				}
			},
			
			/* Public Methods */
			validate : {
				cashCardForm : function(form) {
					let cashPinError = messages.ERR_INVALID_CASHCARDPIN;
					let cashCardNumberError = messages.ERR_INVALID_CASHCARDNO;
					if(TokenGateway.isQuickMembershipCheckout){
						cashPinError = messages.ERR_INVALID_SHOP_CARD_PIN;
						cashCardNumberError=  messages.ERR_INVALID_SHOP_CARD_NO.replace("{0}", TokenGateway.isGiftOfMembership ? messages.RWD_CHECKOUT_COSTCO_GOM_CARD : messages.RWD_CHECKOUT_CASH_CARD);
					}
					if(cashCardNumberError != null) {
						window.digitalDataEvents = window.digitalDataEvents || [];
						digitalDataEvents.push( {uimsg:"Costco Shop Card Balance | You have entered an invalid Costco Shop Card Number"} );
					}	
					if(cashPinError != null) {
						window.digitalDataEvents = window.digitalDataEvents || [];
						digitalDataEvents.push( {uimsg:"Costco Shop Card Balance | You have entered an invalid pin number"} );
					}
					if ($(form).length != 0) {
						var focusPriority = 0;
						$(form).validate({
							onfocusout: true,
							errorElement:'span',
							rules : { 
							cash_pin_validator: { required:true, checkoutajaxcashcardpin:true},
							cash_account_validator: { required:true, checkoutajaxcashcard:true }
						},
						messages: {
							cash_pin_validator:{required: cashPinError, checkoutajaxcashcardpin: cashPinError},
							cash_account_validator: {required: cashCardNumberError, checkoutajaxcashcard: cashCardNumberError}
						},
						errorPlacement: function(error, element) {
                            error.insertAfter(element);
                            if(element[0].getAttribute("id") == "cash_account_validator" ) {
                                $("span[for='cash_account_validator']").attr("role","alert");
                            }
                            if(element[0].getAttribute("id") == "cash_pin_validator" ) {
                                $("span[for='cash_pin_validator']").attr("role","alert");
                            }
                        },
						highlight: function(element, errorClass) {
							if(element.getAttribute("id") == "cash_account_validator" ) {
								$('iframe').filter('.gw-proxy-number').get($('iframe').filter('.gw-proxy-number').length - 1).classList.add('error-credit-card');
								$('#cash_account_error_label').removeClass('hide');
								$('iframe').filter('.gw-proxy-number').get($('iframe').filter('.gw-proxy-number').length - 1).focus();
			                	focusPriority = 1;
			                	
			                } else  {
			                	$('#cash_pin_label').removeClass('hide');
			        		    $('iframe').filter('.gw-proxy-pin').addClass('error-credit-card');
			        		    if(focusPriority == 0) {
			        		    	$('iframe').filter('.gw-proxy-pin').focus();
			        		    }
			        		}
							if(TokenGateway.isQuickMembershipCheckout){
								window.digitalDataEvents = window.digitalDataEvents || [];
								digitalDataEvents.push( { uimsg:"Checkout Flow | " + TokenGateway.isGiftOfMembership ? messages.RWD_CHECKOUT_COSTCO_GOM_CARD : messages.RWD_CHECKOUT_CASH_CARD +" | Successfully Applied" } );
							}	
			               }
						})
					}
					return $(form).valid();

				},	
				ajaxCheckoutCashCardBalanceForm : function(form) {
					if($(form).length != 0) {
						$(form).validate({
							rules : { 
								checkout_ajax_cash_pin_validator: { required:true, checkoutajaxcashcardpin:true},
								checkout_ajax_cash_account_validator: { required:true, checkoutajaxcashcard:true }
							},
							messages: {
								checkout_ajax_cash_pin_validator:{required: TokenGateway.isQuickMembershipCheckout ? messages.ERR_CARD_PIN_REQUIRED : messages.ERR_INVALID_CASHCARDPIN, checkoutajaxcashcardpin: TokenGateway.isQuickMembershipCheckout ? messages.ERR_INVALID_SHOP_CARD_PIN : messages.ERR_INVALID_CASHCARDPIN},
								checkout_ajax_cash_account_validator: {required: TokenGateway.isQuickMembershipCheckout ? messages.ERR_CARD_NO_REQUIRED : messages.ERR_INVALID_CASHCARDNO, checkoutajaxcashcard: TokenGateway.isQuickMembershipCheckout ? messages.ERR_CARD_NO_REQUIRED : messages.ERR_INVALID_CASHCARDNO}
							},
							highlight: function(element, errorClass) {
								if(element.getAttribute("id") == "checkout_ajax_cash_account_validator" ) {
									$('iframe').filter('.gw-proxy-number').get($('iframe').filter('.gw-proxy-number').length - 1).classList.add('error-credit-card');
									$('#checkout_ajax_cash_account_validator').removeClass('hide');
									$('iframe').filter('.gw-proxy-number').get($('iframe').filter('.gw-proxy-number').length - 1).focus();
				                	focusPriority = 1;
				                	
				                } else  {
				                	$('#checkout_ajax_cash_pin_validator').removeClass('hide');
				        		    $('iframe').filter('.gw-proxy-pin').addClass('error-credit-card');
				        		    if(focusPriority == 0) {
				        		    	$('iframe').filter('.gw-proxy-pin').focus();
				        		    }
				        		}
							}	
						})
					}
					return $(form).valid();
				}
			},
			
			submit : function(form, inURL) { 		
				COSTCO.CC.clearMessages();
				COSTCO.CC.clearErrors();
				
				if(COSTCO.CC.isCybersourceEnabled()) {
					if(COSTCO.CC.validateCashCard.cashCardForm('#cash_card_balance_page_form')) {
						
						COSTCO.CC.encryptCashCard('#cash_card_balance_page_form', $('#cash_card_balance_page_form #cash_account').val(), $('#cash_card_balance_page_form #cash_pin').val());
						
						if('' != $('#encryptedCashCardNumber').val() && '' != $('#encryptedCashCardPin').val()){
							$('#cash_card_balance_page_form #cash_account').prop("disabled", true);
							$('#cash_card_balance_page_form #cash_pin').prop("disabled", true);
							$('#cash_card_balance_page_form').submit();
						}
					} else {
						COSTCO.DigitalWallet.resetReCaptcha();
					}
				} else {
					TokenGateway.updateSessionFromForm('giftCard', function(){
						if (COSTCO.CC.validate.cashCardForm('#cash_card_balance_page_form')) {
					    	  $(form)[0].submit();
					      }
					}, 'cash_card_balance_page_form', 'costco_cash_card')
					
				}
				
				return;
			},
			
			createReCaptchaScript: function() {
				const script = document.createElement('script');
				script.src = "https://www.google.com/recaptcha/api.js?onload=onLoadCashCardCallback&render=explicit";
				script.async = true;
				script.defer = true;
				script.onload = () => {
					console.log('ReCaptcha script loaded successfully');
				};
				document.getElementById("tmpl_cash_card_balance_modal").appendChild(script);
			},
			
			showRecaptchaDetails: function() {
				$('#cc-recaptcha-learn-more-link').addClass('hide');
				$('#recaptcha-message-top').focus();
			},
			
			/** Method to call validation method of recaptcha */
			validateReCaptcha: function(grecaptcha){
				grecaptcha.execute();	
			},
			
			/**
		     * this is function opens Check Cash card balance modal
		     */
			openCheckCashCardBalanceModal: function(body) {
				let modalBody = COSTCO.util.tmpl('tmpl_cash_card_balance_modal');
				if (typeof body !== 'undefined' && body !== '') {
					modalBody = body;
				}
				let callerElement = event.target;
				if(costcoStoreFeatures.RECAPTCHA_VALIDATION_ENABLED !== 'undefined' && costcoStoreFeatures.RECAPTCHA_VALIDATION_ENABLED) {
					COSTCO.CC.createReCaptchaScript();
				}
				COSTCO.dialog.returnFocusOnCallerElement(callerElement);
				COSTCO.dialog.createExtDialogBox({
			        title: messages.RWD_CHECK_CASH_CARD_BALANCE,
			        body: modalBody,
			        primary: messages.RWD_CHECK_CASH_CARD_BALANCE,
			        secondary: messages.BUTTON_CANCEL,
			        primary_button_style: 'rounded',
			        secondary_button_style: $('#quick-membership-checkout').length > 0 ? 'tertiary' : 'rounded',
			        preventClose: true,
			        dialogclasses: $('#quick-membership-checkout').length > 0 ? 'cash-card-balance' : '',
			        primary_event: function() {
			        	if(costcoStoreFeatures.RECAPTCHA_VALIDATION_ENABLED !== 'undefined' && costcoStoreFeatures.RECAPTCHA_VALIDATION_ENABLED) {
			        		let widgetId = $('#recaptcha').data('widgetid')
			        		COSTCO.DigitalWallet.executeReCaptcha(widgetId);
			        	} else {
			        		COSTCO.CC.submitCheckCashCardBalanceForm('#checkout-ajax-cash-card-balance-form');
			        	}
			        },
			        secondary_event: function() {
			        	COSTCO.CC.closeCashCardBalanceWidget();
			        },
			        close: function() {
			        	COSTCO.CC.closeCashCardBalanceWidget();
			        },
				});
				if(costcoStoreFeatures.RECAPTCHA_VALIDATION_ENABLED !== 'undefined' && costcoStoreFeatures.RECAPTCHA_VALIDATION_ENABLED) {
					$('#recaptcha-text-modal').removeClass('hide');
				} 
				
				reloadSessionJS('giftCard.number');
			},
			
			/**
		     * this is function closes Check Cash card balance modal
		     */
			closeCashCardBalanceWidget: function() {
				COSTCO.dialog.close();
				
				setTimeout(function() {
	        		reloadSessionJS();
					if(!COSTCO.CC.isCybersourceEnabled()){
	        			$('#cash_account_aux').addClass('hide');
	        			$('#cash_pin_aux').addClass('hide');
	        		}
	        	}, 400);
			},
			
			/**
		     * this is submit function that is used to submit Cash Card balance popover form
		     */
		    submitCheckCashCardBalanceForm: function(form, inURL) {
		    	COSTCO.CC.clearCashBalance(); //clearing cash balance
				COSTCO.CC.clearCashBalanceErrors();	  //clearing errors
				
				if(COSTCO.CC.isCybersourceEnabled()) {
					if(COSTCO.CC.validateCashCard.cashCardForm($(form))) {
						$('#ajax-cash-card-form').addClass('ajax-busy');
						$('#ajax-cash-card-form #cashCardSpinner').removeClass("hidden");
						
						COSTCO.CC.encryptCashCard(form, $(form+' #checkout_ajax_cash_account').val(), $(form+' #checkout_ajax_cash_pin').val());
						
						if('' != $(form+' input[name=encryptedCashCardNumber]').val() && '' != $(form+' input[name=encryptedCashCardPin]').val()){
							$(form+' #checkout_ajax_cash_account').prop("disabled", true);
							$(form+' #checkout_ajax_cash_pin').prop("disabled", true);
							
							COSTCO.CC.ajaxCashCardBalanceCheck(form);
						} else {
							$('#ajax-cash-card-form').removeClass('ajax-busy');
							COSTCO.DigitalWallet.resetReCaptcha();
							$('#ajax-cash-card-form #cashCardSpinner').addClass("hidden");
						}
					} else {
						COSTCO.DigitalWallet.resetReCaptcha();
					}
				} else {
					TokenGateway.updateSessionFromForm('giftCard', function () {
						if (COSTCO.CC.validate.ajaxCheckoutCashCardBalanceForm(form)) {
					    	  COSTCO.CC.ajaxCashCardBalanceCheck(form);
					      }
					}, 'checkout-ajax-cash-card-balance-form', 'costco_cash_card');
				}
				return;
			},
			
			/**
			 * this method is clearing all previous errors regarding cash card
			 */
			clearCashBalanceErrors : function() {
				//removing all errors associated with card number
				COSTCO.CC.clearCashCardNumberErrors();
				
				//removing all errors associated with pin
				COSTCO.CC.clearCashCardPinErrors();
				
				//removing all errors that are not related with wrong/incorrect card number/pin
				COSTCO.CC.clearCashCardTopNotificationErrors();
			},
			/**
			 * this method is setting cash ammount to its default value of - -
			 */
			clearCashBalance: function() {
				$('#checkout-ajax-cash-card-balance-form .cash-card-balance').addClass("hide");
			},

			/**
			 * this function is used to submit request to AjaxCashCardBalanceInquiry
			 * for checking cash card balance
			 */
			ajaxCashCardBalanceCheck: function(form) {
			      return COSTCO.util.ajax({
			          method: 'POST',
			          url: '/AjaxCashCardBalanceInquiry',
			          dataType: 'json',
			          data: $(form).serializeArray(),
			        })
			        .done(COSTCO.util.safe(function(data, textStatus, jqXHR) {
			        	if(data.errorMessageKey == undefined) {
			        		//if there is no error key, transaction is successful
			        		COSTCO.CC.successCashCardBalanceHandler(data);
			        	} else {
			        		//else handle fail flow
			        		COSTCO.CC.failCashCardBalanceHandler(data, form);
			        	}
			        	let widgetId = $('#recaptcha').data('widgetid')
		        		COSTCO.DigitalWallet.resetReCaptcha(widgetId);
			        	$('#ajax-cash-card-form #cashCardSpinner').addClass("hidden");
			        }), 'COSTCO.CC.ajaxCashCardBalanceCheck')
			        //unexpected error flow
			        .fail(COSTCO.CC.unexpectedErrorCashCardBalanceHandler);
		    },
		    
		    /**
		     * this method is used to update cash card balance on cash card widget
		     */
		    successCashCardBalanceHandler: function(data) {
		    	//adding h3-medium-green class to cash balance and setting it to value got from data object
		    	$('#cash-card-amount p').text(COSTCO.util.formatMoney(data.balance, true));
		    	$('#ajax-cash-card-form .cash-card-balance').attr('aria-live','polite');
		    	$('#checkout-ajax-cash-card-balance-form .cash-card-balance').removeClass("hide");
				if(COSTCO.CC.isCybersourceEnabled()) {
		    		COSTCO.CC.bindPrimaryButtonToApplyCashCard();
		    		$('#cashcard-form #encryptedCashCardNumber').val(data.encryptedCashCardNumber);
		    		$('#cashcard-form #encryptedCashCardPin').val(data.encryptedCashCardPin);
		    	} else {
		    		TokenGateway.updateSessionFromForm('giftCard','', 'CashCardForm', 'costco_cash_card');
			    	COSTCO.CC.bindPrimaryButtonToApplyCashCard();
			    	// remove the iframe cash card number & pin and show readonly number & pin
			    	var frm = $('#checkout-ajax-cash-card-balance-form');
			    	frm.find('iframe.gw-proxy-number').remove();
			    	frm.find('iframe.gw-proxy-pin').remove();
			    	$('#cash-card-numb').append('<input class="form-control" readonly value="' + data.checkout_ajax_cash_account_validator + '">');		    	
					$('.cash-card-pin').append('<input class="form-control" readonly value="' + data.checkout_ajax_cash_pin_validator + '">');	
		    	}
		    },
		    
		    bindPrimaryButtonToApplyCashCard: function() {
		    	$('#costcoModalBtn2').unbind().on('click', function() {
		    		COSTCO.CC.applyCashCardFromModal();
		    	});
		    	$('#costcoModalBtn2').text(messages.RWD_CASH_CARD_APPLY);
		    },
		    
		    /**
		     * this method is used to apply cash card from modal
		     * after cash balance was checked
		     */
		    applyCashCardFromModal: function() {
				if(!COSTCO.CC.isCybersourceEnabled()) {
		    		var tokenSessionId = modularTokenSessionId;
					if(TokenGateway.isDualSession && typeof modularCashCardSessionId != 'undefined' && modularCashCardSessionId.length){
						tokenSessionId = modularCashCardSessionId;
					}
					$('#cashCardTokenSessionId').val(tokenSessionId);
		    	} else {
		    		$('#ajax-cash-card-form').addClass('ajax-busy');
					$('#ajax-cash-card-form #cashCardSpinner').removeClass("hidden");
		    	}
				
				var closeModal = function(){
					if (globalPoNote != '') {
						COSTCO.OrderItems.copyPoNotes(globalPoNote);
		    		}
					COSTCO.CC.closeCashCardBalanceWidget();
					if(!COSTCO.CC.isCybersourceEnabled()) {
						if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined') {
					    	COSTCO.CreditCard.initComplete = false;
					    	COSTCO.CreditCard.init();
				    	}
						TokenGateway.refreshGateway();
						COSTCO.CC.addLinkRefresh();
					}
				};
				
				
				COSTCO.Checkout.ajax_update_state({
					error_container: '#cashcard-error-container',
					method: 'POST',
					url: '/CostcoCashCardProcess',
					data: $('#cashcard-form').serializeArray(),
					replaceKey : {original : 'cashcard', replace : 'cashcard'},
					dataType: 'json',
					ajax_update_post_done : closeModal,
					 always: function(){
						 COSTCO.EDDService.callEddService();
						 var pickUpAPIResp = $('#pickUpAPIResponses').val()
						 if(pickUpAPIResp != undefined && pickUpAPIResp != null && pickUpAPIResp != '') {
							 COSTCO.OrderItems.repaintPickUpMolecule(JSON.parse(pickUpAPIResp), true, true);
						 }
						 COSTCO.OrderItems.displayGlobalPickUpAlerts(false, true);
						 
						 if(COSTCO.CC.isCybersourceEnabled()) {
							$('#cashcard-form  #cash_account').prop("disabled", false);
							$('#cashcard-form  #cash_pin').prop("disabled", false);
							$('#ajax-cash-card-form #cashCardSpinner').addClass("hidden");
							$('#ajax-cash-card-form').removeClass('ajax-busy');
						} 
					 }
				});
		    },
		    
		    /**
		     * this method is used to handle error occured while checking cash card balance
		     * wrong pin or invalid cash card ets.
		     */
		    failCashCardBalanceHandler: function(data, form) {
		    	if(data.errorCode == 'ERR_INVALID_CASHCARD_NUMBER') {
		    		//if there is an error with cash card number, we are adding red border to cash card number field
		        	//and printing error beneeth the field
		        	//also in this case we are doing the same with cash card pin fieled
		    		COSTCO.CC.showCashCardNumberErrors();
		    		COSTCO.CC.showCashCardPinErrors();
		    	} else if(data.errorCode == 'ERR_INVALID_CASHCARD_PIN') {
		    		//if there is an error with cash card pin, we are adding red border to cash card pin field
		        	//and printing error beneeth the field
		    		COSTCO.CC.showCashCardPinErrors();
		    	} else {
		    		//if error is not related to cash card pin or cash card number
		    		//we treat that as unexpected error, and forwarding data to method that will handle that error
		    		COSTCO.CC.unexpectedErrorCashCardBalanceHandler(data, form);
		    	}
		    	
		    },
		    
		    /**
		     * this method is used to handle when command exits with unexpected error
		     */
		    unexpectedErrorCashCardBalanceHandler: function(data, form) {
		    	//if unexpected error occurs, we are showing critical notification on top of the cash card widget
		    	//with error message got from data object
		    	$("#error-message")[0].innerHTML = $.parseHTML(data.errorMessage)[0].data;
		    	$('#ajax-cash-card-form #error-message').show();
		    	
				if(undefined !== form && COSTCO.CC.isCybersourceEnabled()) {
		    		$(form+' #checkout_ajax_cash_account').prop("disabled", false);
					$(form+' #checkout_ajax_cash_pin').prop("disabled", false);
		    	}
		    },
		    
		    /**
		     * this method is used to show cash card number error
		     */
		    showCashCardNumberErrors() {
		    	$("[for=checkout_ajax_cash_account_validator]").text(messages.ERR_INVALID_CASHCARDNO);
				$("[for=checkout_ajax_cash_account_validator]").show();
				$("[id=checkout_ajax_cash_account]").addClass('validation-error');
		    },
		    
		    /**
		     * this method is used to show cash card pin error
		     */
		    showCashCardPinErrors() {
		    	$("[for=checkout_ajax_cash_pin_validator]").text(messages.ERR_INVALID_CASHCARDPIN);
				$("[for=checkout_ajax_cash_pin_validator]").show();
				$("[id=checkout_ajax_cash_pin]").addClass('validation-error');
		    },
		    
		    /**
		     * this method is used to clear cash card number error
		     */
		    clearCashCardNumberErrors() {
		    	$("[id=checkout_ajax_cash_account]").removeClass('validation-error');
				$("[for=checkout_ajax_cash_account_validator]").hide();
				$("[for=checkout_ajax_cash_account_validator]").text('');
		    },
		    
		    /**
		     * this method is used to clear cash card pin error
		     */
		    clearCashCardPinErrors() {
		    	$("[id=checkout_ajax_cash_pin]").removeClass('validation-error');
				$("[for=checkout_ajax_cash_pin_validator]").hide();
				$("[for=checkout_ajax_cash_pin_validator]").text('');
		    },
		    
		    /**
		     * this method is used to show cash card top notification error
		     */
		    clearCashCardTopNotificationErrors() {
		    	$('#ajax-cash-card-form #error-message').hide()
		    },
		    
		    /**
			 * this function is used to submit request to remove cash card
			 * link for removing is passed and form, that is parent to that link, is sent to command
			 */
		    removeCashCard: function(link) {
		    	if ($(link).parent().find('input[name=isPurchaseMembershipAutoRenew]').length > 0) {
					var ftcAutoRenewConsentObj = COSTCO.CreditCard.forms.creditCardForm().find('input[name=isPurchaseMembershipAutoRenew]');
					if (ftcAutoRenewConsentObj.length > 0) $(link).parent().find('input[name=isPurchaseMembershipAutoRenew]').val(ftcAutoRenewConsentObj.val());
				}
		    	COSTCO.Checkout.ajax_update_state({
			          error_container: '#cashcard-error-container',
			          method: 'POST',
			          url: '/CostcoCashCardProcess',
			          data: $(link).parent().serializeArray(),
			          dataType: 'json',
			          always: function(){
				          	COSTCO.EDDService.callEddService();    	
				          },
			          done: function(data, textStatus, jqXHR, options) {
			        	setTimeout(function() {
			        		COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
							if(COSTCO.CC.isCybersourceEnabled()){ 
								TokenGateway.refreshGateway();
							}
			        		COSTCO.CC.addLinkRefresh();
			        	},0);
				    	if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined') {
					    	COSTCO.CreditCard.initComplete = false;
				    	}

						let application = data.error.application || [];
						let exception = data.error.exception || [];
						
						if(COSTCO.DigitalWallet.digitalWalletApplied && application.length == 0 && exception.length == 0){
							$("#dw-checkout-form input[name=action]").val('add');
				    		COSTCO.DigitalWallet.addDigitalWallet();
				    	}
						if(!COSTCO.CC.isCybersourceEnabled()){ 
							TokenGateway.refreshGateway();
						}
			    	}
			    });
		    },
			
			clearErrors : function() {
				$("[for=cash_account_validator]").text('');
				$("[for=cash_pin_validator]").text('');
				$("[id=error_message]").text('');
				
				$("[id=cash_account]").removeClass('error');
				$('label[for="cash_account"]').each(function(){
					if($(this).hasClass('error')) {
						$(this).hide();
						$(this).text('');
					}
				});
								
				$("[id=cash_pin]").removeClass('error');
				$('label[for="cash_pin"]').each(function(){
					if($(this).hasClass('error')) {
						$(this).hide();
						$(this).text('');
					}
				});
			},
			clearMessages: function() {
				let messageWrapperElement = $('#cash_card_balance .messages');
				let messageElement = messageWrapperElement.find('.success');
				if (messageElement.length == 0) {
					messageElement = messageWrapperElement.find('.error');
				}
				
				if (messageElement.length) {
					messageElement.remove();
				}
			},
			addCashCard : function(cctype) {
				if(typeof cctype !== 'undefined' && cctype !== '' && cctype === 'GOM') {
					$('#gomcard-block').addClass('hide');
				} else {
					$('#cashcard-block').addClass('hide');
				}
				if(!wallet.isComplete()){
				  $('#address-container-billing').removeClass('hide');
				}
				COSTCO.CC.unhideInput();
			},
			applyCashCard : function(cctype) {
				
				var refreshGateway = function(data){
					if($('#quick-membership-checkout').length > 0 && data.error !== undefined 
							&& (data.error.application.length == 0 && data.error.exception.length == 0)) {
						window.digitalDataEvents = window.digitalDataEvents || [];
		        		digitalDataEvents.push( { uimsg:"Checkout Flow | " + TokenGateway.isGiftOfMembership ? messages.RWD_CHECKOUT_COSTCO_GOM_CARD : messages.RWD_CHECKOUT_CASH_CARD +" | Successfully Applied" } );
					}
					
					if(COSTCO.CC.isCybersourceEnabled()) {
						$('#cashcard-form  #cash_account').prop("disabled", false);
						$('#cashcard-form  #cash_pin').prop("disabled", false);
						$('#cashcard-block-form #cashCardSpinner').addClass("hidden");
						$('#cashcard-block-form').removeClass('ajax-busy');
					}
					if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && typeof COSTCO.CreditCard !== 'undefined') {
				    	COSTCO.CreditCard.initComplete = false;
				    	COSTCO.CreditCard.init();
			    	}
					TokenGateway.refreshGateway();
					
					COSTCO.CC.addLinkRefresh();
					if (globalPoNote != '') {
						COSTCO.OrderItems.copyPoNotes(globalPoNote);
		    		}
					if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && !(COSTCO.applepay.isApplePayApplied() || COSTCO.applepay.isApplePayUsed() )) {
						COSTCO.wallet.showCCSection();
					}
					
					let application = data.error.application || [];
					let exception = data.error.exception || [];
					
					if(COSTCO.DigitalWallet.digitalWalletApplied && application.length == 0 && exception.length == 0){
						$("#dw-checkout-form input[name=action]").val('add');
			    		COSTCO.DigitalWallet.addDigitalWallet();
			    	}
				};
				
				var cashCardAjax = function(){
				      COSTCO.Checkout.ajax_update_state({
				          error_container: '#cashcard-error-container',
				          method: 'POST',
				          url: '/CostcoCashCardProcess',
				          data: $('#cashcard-form').serializeArray(),
				          replaceKey : {original : 'cashcard', replace : 'cashcard'},
				          dataType: 'json',
				          ajax_update_post_done : refreshGateway,
				          always: function(){
				          	COSTCO.EDDService.callEddService();    	
				          	if(checkoutPage === 'review') {
				          		var pickUpAPIResp = $('#pickUpAPIResponses').val()
				          	  	if(pickUpAPIResp != undefined && pickUpAPIResp != null && pickUpAPIResp != '') {
				          	  		COSTCO.OrderItems.repaintPickUpMolecule(JSON.parse(pickUpAPIResp), true, true);
				          	  	}
				          		COSTCO.OrderItems.displayGlobalPickUpAlerts(false, true);
								COSTCO.OrderItems.addQuantityEventHandlers();
				          	}
				          }
				        })
				};
				
				if(COSTCO.CC.isCybersourceEnabled()) {
					if(COSTCO.CC.validateCashCard.cashCardForm($('#cashcard-form'))) {
						$('#cashcard-block-form').addClass('ajax-busy');
						$('#cashcard-block-form #cashCardSpinner').removeClass("hidden");
						
						let form = '#cashcard-form';
						COSTCO.CC.encryptCashCard(form, $(form+' #cash_account').val(), $(form+' #cash_pin').val());
						
						if('' != $(form+' input[name=encryptedCashCardNumber]').val() && '' != $(form+' input[name=encryptedCashCardPin]').val()){
							$(form+' #cash_account').prop("disabled", true);
							$(form+' #cash_pin').prop("disabled", true);
							
							cashCardAjax();
						} else {
							$('#cashcard-block-form').removeClass('ajax-busy');
							COSTCO.DigitalWallet.resetReCaptcha();
							$('#cashcard-block-form #cashCardSpinner').addClass("hidden");
						}
					}
				} else {
					TokenGateway.updateSessionFromForm('giftCard',cashCardAjax, 'CashCardForm', 'costco_cash_card');
				}
				
			},
			checkBalance : function() {
				if (CashCard.validate.cashCardForm(this.form)) {
					CashCard.submit(this.form, "/CashCardInquiry");
				}
			},
			addCashCard_v2: function(cctype, orderId, addNew) {
				COSTCO.CC.renderCashCardForm(cctype, orderId);
				if(addNew){
					COSTCO.CC.addCashCard(cctype);
				} else {
					$('#cashcard-refresh-area #cashcard-block-form').addClass('no-border-bottom');
					COSTCO.CC.unhideInput();
				}
				
				reloadSessionJS('giftCard.number');
				//TBD Focus Issue
				//$("#cashcard-form").find("iframe").get(0).focus();
			},
			renderCashCardForm: function(cctype, orderId) {
				$('#cashcard-refresh-area #cashcard-error-container').remove();
				$('#cashcard-refresh-area #cashcard-block-form').remove();
				let cashCardBlock = '#cashcard-block';
				if(typeof cctype !== 'undefined' && cctype !== '' && cctype === 'GOM') {
					cashCardBlock = '#gomcard-block';
					$('#cashcard-block').removeClass('hide');
				} else {
					$('#gomcard-block').removeClass('hide');
				}
				
				let template = COSTCO.util.tmpl('tmpl_add_cash_card',{
					orderId : orderId,
					type : cctype
				});
				$(template).insertBefore(cashCardBlock);
				
				if($('#cashcard-block-form #hidden_displayShopCard').length > 0) 
					$('#cashcard-block-form #hidden_displayShopCard').val(COSTCO.DigitalWallet.displayShopCard);
				
				if($('#cashcard-block-form').find('input[name=isPurchaseMembershipAutoRenew]').length > 0){
					let ftcAutoRenewConsentObj = COSTCO.CreditCard.forms.creditCardForm().find('input[name=isPurchaseMembershipAutoRenew]');
                	if(ftcAutoRenewConsentObj.length > 0)
                		$('#cashcard-block-form').find('input[name=isPurchaseMembershipAutoRenew]').val(ftcAutoRenewConsentObj.val());
				}
			},
			openCashCardCheckBalanceModal: function(cctype, orderId) {
				COSTCO.CC.renderCashCardForm(cctype, orderId);
				$('.card-info-body').removeClass('hide');
				let modalBody = COSTCO.util.tmpl('tmpl_new_cash_card_balance_modal', {
					orderId: orderId,
					type: cctype
				});
				COSTCO.CC.openCheckCashCardBalanceModal(modalBody);
			},
			
			encryptCashCard: function(form, cashCardAccount, cashCardPin) {
				if(undefined !== form && undefined !== cashCardAccount && undefined !== cashCardPin) {
					
					if(null == COSTCO.DigitalWallet.paymentsHubPublicKey || null == COSTCO.DigitalWallet.paymentsHubAlgorithm || null == COSTCO.DigitalWallet.paymentsHubKeyId) {
						// gets user JWT token
			            let userToken = COSTCO.DigitalWallet.getUserToken();		            
						
						if(null != userToken) {
							// gets public key to encrypt shop card number & pin
							let encryptionKeyResponse = COSTCO.DigitalWallet.getWalletEncryptionKey(userToken);
							COSTCO.DigitalWallet.paymentsHubPublicKey = encryptionKeyResponse.publicKey;
							COSTCO.DigitalWallet.paymentsHubAlgorithm = encryptionKeyResponse.algorithm;
							COSTCO.DigitalWallet.paymentsHubKeyId = encryptionKeyResponse.id;
						}
					}
					
					let shopCardNumber = cashCardAccount.split(" ").join("");
					let encryptedCardNo = COSTCO.DigitalWallet.encryptField(shopCardNumber, COSTCO.DigitalWallet.paymentsHubKeyId,
															COSTCO.DigitalWallet.paymentsHubPublicKey, COSTCO.DigitalWallet.paymentsHubAlgorithm);

					let encryptedPin = COSTCO.DigitalWallet.encryptField(cashCardPin, COSTCO.DigitalWallet.paymentsHubKeyId,
															COSTCO.DigitalWallet.paymentsHubPublicKey, COSTCO.DigitalWallet.paymentsHubAlgorithm);
					
					$(form+" input[name=encryptedCashCardNumber]").val("ENC_["+encryptedCardNo+"]");
					$(form+" input[name=encryptedCashCardPin]").val("ENC_["+encryptedPin+"]");
					/*
					// gets user JWT token
		            let userToken = COSTCO.DigitalWallet.getUserToken();		            
					
					if(null != userToken) {
						// gets public key to encrypt shop card number & pin
						let encryptionKeyResponse = COSTCO.DigitalWallet.getWalletEncryptionKey(userToken);
						
					}*/
				}
			},
			
			isCybersourceEnabled: function(){
				return ($("#cybersourceEnabled").val() ==='true');
			}
			
			
	}
	
	if(typeof window.COSTCO == 'undefined'){
		window.COSTCO = new Object();
	}
	
	window.COSTCO.CC = CashCard
	CashCard.validationRules();
	return CashCard;
});



// WEBPACK FOOTER //
// ./js/account/cashcard.js